import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Combobox, Panel } from '@mairistem/finances-utils';
import type { DropdownOption } from '@mairistem/liste';
import React from 'react';
import ARTICLE_NON_BUDGETAIRE_OPTIONS from '../../../constants/mouvements/articleNonBudgetaireOptions';
import CODE_BHM from '../../../constants/mouvements/codeBHM';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

/**
 * Permet de trier la liste des articles non budgétaires par rapport à la date de caducité
 * et à la valeur actuelle sur la ligne
 * @param code de l'article non budgétaire
 */
const filterOptions = (code: string): DropdownOption[] =>
	ARTICLE_NON_BUDGETAIRE_OPTIONS.filter(
		(article) => article.dateCaduque === null || article.value === code,
	);

const ArticleNonBudgetaireComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					control={Combobox}
					data-testid="codeArticleNonBudgetaire"
					disabled={data?.codeBHM === CODE_BHM.VALUE.HISTORISE}
					fluid
					key="codeArticleNonBudgetaire"
					label="Articles non budgétaires"
					name="codeArticleNonBudgetaire"
					onChange={handleChange}
					options={filterOptions(data?.codeArticleNonBudgetaire)}
					placeholder={data?.codeArticleNonBudgetaire === MULTI ? MULTI : ''}
					search
					selection
					value={data?.codeArticleNonBudgetaire ?? null}
				/>
			</Form>
		</Panel>
	);
};

export default ArticleNonBudgetaireComponent;
